import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
import addLocation from './component/addLocation.vue';
export default {
  name: "teamInfo",
  mixins: [loadMoreList, commonData],
  components: {
    addLocation: addLocation
  },
  props: ['teamId'],
  data: function data() {
    return {
      formData: {
        name: "",
        logo: "",
        introduction: "",
        age_group: '',
        can_register: "",
        registration_fee: "",
        venue_id: '',
        location_name: '',
        team_vibe: []
      },
      imgList: [],
      ageGroupList: [],
      rules: {
        name: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }],
        logo: [{
          required: true,
          message: "请上传球队logo",
          trigger: "blur"
        }],
        age_group: [{
          required: true,
          message: "请输入年龄组",
          trigger: "blur"
        }],
        can_register: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        location_name: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        registration_fee: [{
          required: true,
          message: "请输入报名费用",
          trigger: "blur"
        }],
        introduction: [{
          required: true,
          message: "请输入简介",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    this.getTeamInfo();
    this.getAgeGroupListFn();
  },
  methods: {
    getAgeGroupListFn: function getAgeGroupListFn() {
      var _this = this;

      this.$api.ageGroupList().then(function (res) {
        if (res.code == 200) {
          _this.ageGroupList = res.data;
        }
      });
    },
    addContent: function addContent() {
      this.formData.team_vibe.push({
        value: ''
      });
    },
    removeContent: function removeContent(item) {
      var index = this.formData.team_vibe.indexOf(item);

      if (index !== -1) {
        this.formData.team_vibe.splice(index, 1);
      }
    },
    imgChange: function imgChange(e) {
      this.imgList = e;
      this.formData.logo = e[0] && e[0].response ? e[0].response.url : '';
    },
    getTeamInfo: function getTeamInfo() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$api.teamInfo({
                  id: _this2.teamId
                }).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data;
                    data.location_name = data.venue ? data.venue.location_name : '';
                    var datas = JSON.parse(JSON.stringify(data));
                    var teamVibe = data.team_vibe ? JSON.parse(data.team_vibe) : [];
                    datas.team_vibe = teamVibe.map(function (item) {
                      return {
                        value: item
                      };
                    });
                    _this2.formData = _objectSpread({}, datas);
                    _this2.imgList = [datas.logo];
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    changeLocation: function changeLocation(data) {
      console.log("data===", data);

      if (data) {
        var newData = data.split(",");
        this.formData.venue_id = newData[0];
        this.formData.location_name = newData[1];
        console.log("newData==", newData);
      }
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this3.formData));
          data.team_vibe = data.team_vibe.map(function (item) {
            return item.value;
          });
          data.team_vibe = JSON.stringify(data.team_vibe);
          var params = {
            id: _this3.teamId,
            name: data.name,
            logo: data.logo,
            introduction: data.introduction,
            age_group: data.age_group,
            can_register: data.can_register,
            registration_fee: data.registration_fee,
            venue_id: data.venue_id,
            team_vibe: data.team_vibe
          };

          _this3.$api.updateTeams(params).then(function (res) {
            if (res.code == 200) {
              _this3.$message.success('操作成功');
            } else {
              _this3.$message.error(res.msg);
            }
          });
        }
      });
    }
  }
};